<i18n>
{
	"en": {
		"code": "Code",
		"description": "Description",
		"availableFor": "Available for Deviation Type",
		"cancelLabel": "Cancel",
		"editTemplate": "Edit Deviation Cause Template",
		"newTemplate": "New Deviation Cause Template",
		"newTemplateSaved": "Deviation Cause Template Saved",
		"save": "Save"
	},
	"no": {
		"code": "Kode",
		"description": "Beskrivelse",
		"availableFor": "Tilgjengelig for avvikstype",
		"cancelLabel": "Avbryt",
		"editTemplate": "Rediger Avviksårsak",
		"newTemplate": "Ny Avviksårsak",
		"newTemplateSaved": "Avviksårsak Lagret",
		"save": "Lagre"
	}
}
</i18n>
<template>
	<t-dialog
		:isShown="showEditDeviationCause"
		:title="deviationCauseEditId ? $t('editTemplate') : $t('newTemplate')"
		:confirmLabel="$t('save')"
		:cancelLabel="$t('cancelLabel')"
		:icon="deviationCauseEditId ? 'trip' : 'trip-new'"
		:isConfirmDisabled="!deviationCauseTemplate.code.length"
		width="900px"
		@close="close"
		@ok="save"
	>
		<div class="new-template">
			<t-form-group :title="$t('code')" rowGap="5px" style="grid-column: 1/2;">
				<t-text-input v-model="deviationCauseTemplate.code" />
			</t-form-group>
			<t-form-group :title="$t('description')" rowGap="5px" style="grid-column: 1/2;">
				<t-text-input v-model="deviationCauseTemplate.description" />
			</t-form-group>
			<t-form-group :title="$t('availableFor')" rowGap="5px" style="grid-column: 1/2;">
				<t-text-input v-model="deviationCauseTemplate.availableFor" />
			</t-form-group>
		</div>
	</t-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from './store/deviations.store.js';

export default {
	name: 'EditDeviationCause',
	computed: {
		...mapState([
			'showEditDeviationCause',
			'deviationCauseEditId',
			'deviationCauseTemplate',
		])
	},
	methods: {
		...mapActions(['saveDeviationCauseTemplate']),
		...mapMutations(['resetDeviationCauseTemplate']),
		close() {
			this.resetDeviationCauseTemplate();
		},
		async save() {
			return;
			// try {
			// 	await this.saveDeviationCauseTemplate();
			// 	this.$notify({
			// 		type: 'success',
			// 		title: `${this.$t('newTemplateSaved')}: ${this.deviationCauseTemplate.code}`
			// 	});
			// } catch (err) {
			// 	this.$notify({
			// 		type: 'error',
			// 		title: this.$t(err.message),
			// 		duration: -1
			// 	});
			// }
		}
	}
};
</script>


<style lang="scss" scoped>

.new-template {
	display: grid;
	grid-template-columns: repeat(4, minmax(200px, 1fr));
	column-gap: 20px;
	row-gap: 20px;
}

</style>
